import { IOfferCard } from '../../../../types/card';
import { ELabelColor, ILabel } from '../../../../types/label';
import { getGoodPriceLabel, getIsRosreestrCheckedLabel, getIsUniqueLabel } from '../../utils';

export const prepareLabels = (offerCard: IOfferCard) => {
  const offersLabels = offerCard.offerFeatureLabels || [];

  return [
    ...offersLabels.map(text => ({ color: ELabelColor.DarkGray, text })),
    // Лейбл "Хорошая цена"
    getGoodPriceLabel(offerCard),
    // Лейбл "Только на ЦИАН"
    getIsUniqueLabel(offerCard),
    // Лейбл "Проверено в Росреестре"
    getIsRosreestrCheckedLabel(offerCard),
  ].filter(Boolean) as ILabel[];
};
